import { Injectable } from "@angular/core";
import { ClientService } from "../../services/client.service";
import {
  Actions,
  createEffect,
  ofType
} from "@ngrx/effects";
import { ClientActions } from "./client.actions";
import { from, mergeMap } from "rxjs";
import { Plan } from "../../class/plan.class";



@Injectable()
export class ClientEffect {
  constructor(
    private clientService: ClientService,
    private action$: Actions
  ) { }


  loadClient$ = createEffect(() =>
    this.action$.pipe(
      ofType(ClientActions.loadClient),
      mergeMap(() =>
        this.clientService.getClientData().pipe(
          mergeMap((meResponse: any) => {
            const client = meResponse;
            return from([
              ClientActions.loginClient({ client: client }),
              ClientActions.setTokens({ tokens: client.plan.token_left }),
              ClientActions.setTokensPerMonth({ tokens: client.plan.token_per_month }),
              ClientActions.setPlan({ plan: new Plan(client.plan) })
            ]);
          })
        )
      )
    )
  );
}